import React, { useEffect, useMemo, useState } from 'react';
import { Alert, Badge, Card, Col, Row, Table } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import UserLayout from '../../components/user/UserLayout';
import api from '../../lib/api';

export default function UserWidgetAnalyticsPage() {
  const [widgets, setWidgets] = useState([]);
  const [msg, setMsg] = useState('');

  useEffect(() => {
    api.get('/user/widgets/analytics/')
      .then((res) => setWidgets(Array.isArray(res.data) ? res.data : []))
      .catch(() => setMsg('Unable to load widget analytics.'));
  }, []);

  const totals = useMemo(() => {
    return widgets.reduce((acc, w) => {
      acc.chats += Number(w.chat_count || 0);
      const feedback = Array.isArray(w.feedback_stats) ? w.feedback_stats : [];
      feedback.forEach((f) => {
        if (f.feedback === 'positive') acc.positive += Number(f.count || 0);
        if (f.feedback === 'negative') acc.negative += Number(f.count || 0);
      });
      return acc;
    }, { chats: 0, positive: 0, negative: 0 });
  }, [widgets]);

  return (
    <UserLayout title="Widget Analytics" subtitle="Track analytics for your workspace widgets">
      {msg ? <Alert variant="info">{msg}</Alert> : null}

      <Row className="g-3 mb-4">
        <Col md={4}><Card className="user-stat-card p-3"><div className="user-stat-label">Total Widget Chats</div><div className="user-stat-value">{totals.chats}</div></Card></Col>
        <Col md={4}><Card className="user-stat-card p-3"><div className="user-stat-label">Positive Feedback</div><div className="user-stat-value">{totals.positive}</div></Card></Col>
        <Col md={4}><Card className="user-stat-card p-3"><div className="user-stat-label">Negative Feedback</div><div className="user-stat-value">{totals.negative}</div></Card></Col>
      </Row>

      <Card className="user-card p-4">
        <div className="user-section-title">Widgets</div>
        <div className="table-responsive user-table-wrap">
          <Table hover>
            <thead>
              <tr>
                <th>Widget</th>
                <th>Status</th>
                <th>Chats</th>
                <th>Last Chat</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {widgets.map((w) => (
                <tr key={w.token}>
                  <td>{w.name || w.brand_name || w.token}</td>
                  <td><Badge bg={w.is_active ? 'success' : 'secondary'}>{w.is_active ? 'Active' : 'Disabled'}</Badge></td>
                  <td>{w.chat_count || 0}</td>
                  <td>{w.last_chat ? new Date(w.last_chat).toLocaleString() : '—'}</td>
                  <td>
                    <Link to={`/dashboard/widgets/${w.token}/chats`} className="btn btn-sm btn-outline-dark">View Chats</Link>
                  </td>
                </tr>
              ))}
              {!widgets.length ? <tr><td colSpan={5} className="text-center text-muted py-4">No widget analytics yet.</td></tr> : null}
            </tbody>
          </Table>
        </div>
      </Card>
    </UserLayout>
  );
}
